export default "__VITE_ASSET__Uy1PYcJ5__"